export default __webpack_public_path__ + "static/media/hotel-icon.d83d7f96.svg";